import { MAKE } from 'next-common';
import { IVehicleStock, IVehicleStockResult } from '../../interfaces';
import { useClientQuery } from '../useClientQuery';
import { NEXT_ENTITY } from '@common/interfaces/entity';
import { WatchQueryFetchPolicy } from '@apollo/client';

export interface IVehicleStockParams {
  make?: MAKE;
  series?: string;
  serialNo: string;
  refreshKey?: string | number;
  fetchPolicy?: WatchQueryFetchPolicy;
}

export const useClientVehicleStock = (params: IVehicleStockParams, nextOptions?: any): IVehicleStockResult => {
  const { data, loading } = useClientQuery(NEXT_ENTITY.VEHICLE_STOCK_OF_SELECTED_SERIAL_NO, {
    variables: {
      serialNo: params?.serialNo,
    },
    watch: [params?.refreshKey],
    skip: !params?.serialNo,
    nextOptions: nextOptions || { revalidate: 60 },
    defaultLoading: true,
  });
  const stock = (data || null) as unknown as IVehicleStock;
  return { data: stock, loading };
};
